<div>
  <app-subnav
    leftButtonText="{{ !isUpdated ? 'Back' : !isSubmitted ? '' : 'Back' }}"
    leftButtonClass="{{ !isUpdated ? '--chevron--left' : !isSubmitted ? '' : '--chevron--left' }}"
    leftButtonIcon="{{ !isUpdated ? '' : !isSubmitted ? 'trash_24' : '' }}"
    [isRightButton]="!isSubmitted"
    (leftButtonClicked)="leftButtonClicked($event)"
    (rightButtonClicked)="rightButtonClicked()"
  ></app-subnav>
</div>

<div id="contractorPage" data-testid="contractorPage" class="contractorPage">
  <div class="-oneX-container">
    <div class="-oneX-row -oneX-justify-content-center">
      <div
        class="-oneX-col-12 -oneX-offset-0 -oneX-col-sm-8 -oneX-offset-sm-0 -oneX-col-md-6 -oneX-offset-md-0 -oneX-col-lg-6 -oneX-offset-lg-0 -oneX-col-xl-6 -oneX-offset-xl-0"
      >
        <h3
          id="contractorDetailsTitle"
          data-testid="contractorDetailsTitle"
          [ngClass]="isUpdated ? 'edit-details-title' : 'contractor-details-title'"
        >
          {{
            !isUpdated
              ? "Let's gather some information about your contract"
              : !isSubmitted
              ? 'Edit contract details'
              : 'Information gathered about submitted contract'
          }}
        </h3>
      </div>
    </div>

    <div class="-oneX-row -oneX-justify-content-center">
      <div
        class="-oneX-col-12 -oneX-offset-0 -oneX-col-sm-8 -oneX-offset-sm-0 -oneX-col-md-6 -oneX-offset-md-0 -oneX-col-lg-6 -oneX-offset-lg-0 -oneX-col-xl-6 -oneX-offset-xl-0"
      >
        <div
          id="contractorDetailsAllFieldsText"
          data-testid="contractorDetailsAllFieldsText"
          class="-oneX-body--tertiary fields-required-text"
        >
          All fields are required.
        </div>
      </div>
    </div>

    <div class="-oneX-row -oneX-justify-content-center">
      <div
        class="-oneX-col-12 -oneX-offset-0 -oneX-col-sm-8 -oneX-offset-sm-0 -oneX-col-md-6 -oneX-offset-md-0 -oneX-col-lg-6 -oneX-offset-lg-0 -oneX-col-xl-6 -oneX-offset-xl-0"
      >
        <div class="contractor-input-container">
          <label for="contractorName" class="-oneX-textfield__floatingLabel"> Name of Contractor </label>
          <input id="contractorName" type="text" class="-oneX-textfield--floating-input" maxlength="100" />
        </div>
      </div>
    </div>

    <div class="-oneX-row -oneX-justify-content-center">
      <div
        class="-oneX-col-12 -oneX-offset-0 -oneX-col-sm-8 -oneX-offset-sm-0 -oneX-col-md-6 -oneX-offset-md-0 -oneX-col-lg-6 -oneX-offset-lg-0 -oneX-col-xl-6 -oneX-offset-xl-0"
      >
        <div class="contractor-input-container">
          <label for="contractorPhoneNumber" class="-oneX-textfield__floatingLabel"> Contractor's phone number </label>
          <input id="contractorPhoneNumber" type="tel" class="-oneX-textfield--floating-input" data-formatter="phone" />
        </div>
      </div>
    </div>

    <div class="-oneX-row -oneX-justify-content-center">
      <div
        class="-oneX-col-12 -oneX-offset-0 -oneX-col-sm-8 -oneX-offset-sm-0 -oneX-col-md-6 -oneX-offset-md-0 -oneX-col-lg-6 -oneX-offset-lg-0 -oneX-col-xl-6 -oneX-offset-xl-0"
      >
        <div class="contractor-input-container">
          <fieldset class="-oneX-fieldset">
            <label for="contractorSignDate" class="-oneX-textfield__floatingLabel labelDate">
              Contract signed (MM-DD-YYYY)
            </label>
            <input
              id="contractorSignDate"
              type="text"
              data-formatter="date"
              class="-oneX-textfield__input -oneX-textfield--control"
              (change)="updateDate($event)"
              data-testid="contractorSignDate"
            />
            <button id="contractorSignDateBtn" class="-oneX-btn-control">
              <div aria-label="datepicker" role="img" class="-oneX-icon--controls--calendar"></div>
            </button>
          </fieldset>
          <div id="errorMessage" class="-oneX-widget__err-text" style="display: none">Cannot enter a future date</div>
        </div>
      </div>
    </div>

    <div class="-oneX-row -oneX-justify-content-center">
      <div
        class="-oneX-col-12 -oneX-offset-0 -oneX-col-sm-8 -oneX-offset-sm-0 -oneX-col-md-6 -oneX-offset-md-0 -oneX-col-lg-6 -oneX-offset-lg-0 -oneX-col-xl-6 -oneX-offset-xl-0"
      >
        <div class="contractor-input-container">
          <label for="contractAmount" class="-oneX-textfield__floatingLabel"> Total amount of contract </label>
          <input
            id="contractAmount"
            type="text"
            class="-oneX-textfield--floating-input"
            data-formatter="currency"
            maxlength="15"
          />
        </div>
      </div>
    </div>

    <div class="-oneX-row -oneX-justify-content-center">
      <div
        class="-oneX-col-12 -oneX-offset-0 -oneX-col-sm-8 -oneX-offset-sm-0 -oneX-col-md-6 -oneX-offset-md-0 -oneX-col-lg-6 -oneX-offset-lg-0 -oneX-col-xl-6 -oneX-offset-xl-0"
      >
        <div class="contractor-input-container">
          <label for="repairsUnderway" class="-oneX-dropdown__conversationalLabel corners-text">
            Are the repairs completed or substantially underway?
          </label>
          <div class="-oneX">
            <div>
              <select #repairsUnderway id="repairsUnderway" type="text" class="-oneX-dropdown">
                <option value=""></option>
                <option value="Yes">Yes</option>
                <option value="No">No</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="-oneX-row -oneX-justify-content-center">
      <div
        class="-oneX-col-12 -oneX-offset-0 -oneX-col-sm-8 -oneX-offset-sm-0 -oneX-col-md-6 -oneX-offset-md-0 -oneX-col-lg-6 -oneX-offset-lg-0 -oneX-col-xl-6 -oneX-offset-xl-0"
      >
        <label for="estimateDiscrepancy" class="-oneX-dropdown__conversationalLabel">
          Review your State Farm estimate. Are there any differences between the repairs done (or underway) and what
          State Farm has listed on your damage estimate?
        </label>
        <div class="-oneX">
          <div>
            <select #estimateDiscrepancy id="estimateDiscrepancy" type="text" class="-oneX-dropdown">
              <option value=""></option>
              <option value="Yes">Yes</option>
              <option value="No">No</option>
            </select>
          </div>
        </div>
      </div>
    </div>

    <div class="-oneX-row -oneX-justify-content-center">
      <div
        class="-oneX-col-12 -oneX-offset-0 -oneX-col-sm-8 -oneX-offset-sm-0 -oneX-col-md-6 -oneX-offset-md-0 -oneX-col-lg-6 -oneX-offset-lg-0 -oneX-col-xl-6 -oneX-offset-xl-0"
      >
        <div class="corners-text">
          <a
            id="commonDocModalBtn"
            data-testid="commonDocModalBtn"
            class="-oneX-link--block"
            (click)="openCommonDocModal($event)"
            (keydown.enter)="openCommonDocModal($event)"
            tabindex="0"
          >
            Common documentation types
          </a>
        </div>
      </div>
    </div>

    <div class="-oneX-row -oneX-justify-content-center">
      <div
        class="-oneX-col-12 -oneX-offset-0 -oneX-col-sm-8 -oneX-offset-sm-0 -oneX-col-md-6 -oneX-offset-md-0 -oneX-col-lg-6 -oneX-offset-lg-0 -oneX-col-xl-6 -oneX-offset-xl-0"
      >
        <div
          id="contractorUploadPhotosInputContainer"
          data-testid="contractorUploadPhotosInputContainer"
          class="upload-container"
          appDragAndDrop
          (fileDropped)="addFiles($event)"
          (click)="fileUploadClick($event)"
          (keydown.enter)="fileUploadClick($event)"
        >
          <div>
            <div
              role="button"
              tabindex="0"
              aria-label="Add new contractor documentation"
              id="contractorUploadPhotosInput"
              data-testid="contractorUploadPhotosInput"
            >
              <input
                accept="image/png,image/jpeg,image/jpg"
                multiple
                type="file"
                autocomplete="off"
                tabindex="-1"
                id="contractorUploadPhotosInput_control"
                data-testid="contractorUploadPhotosInput_control"
                style="display: none"
                #fileDropRef
                (change)="addFiles(fileDropRef.files!)"
                [disabled]="contractList.length >= MAX_CONTRACT_PHOTOS || isSubmitted"
              />
              <div
                class="upload-files-dropzone"
                [ngClass]="contractList.length > 0 ? 'urp-container' : 'urp-container-empty'"
                [class.urp-container-error]="hasFileSizeError || hasFileTypeError"
              >
                <div class="-oneX-container">
                  <div class="-oneX-row" style="justify-content: center; align-items: center"></div>
                  <div class="-oneX-row" style="justify-content: center; align-items: center">
                    <ng-template [ngIf]="contractList.length === 0">
                      <div
                        id="urp-photo-add-files-icon"
                        data-testid="urp-photo-add-files-icon"
                        class="upload-files-dropzone add-photos-icon-container"
                      >
                        <img
                          src="data:image/svg+xml;base64,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"
                          tabindex="0"
                          alt="Add contractor"
                          aria-label="Add contractor photo"
                          data-testid="addFilesIconImg"
                          id="addFilesIconImg"
                          role="button"
                        />
                      </div>
                    </ng-template>
                    <ng-template [ngIf]="contractList.length > 0">
                      <ng-container *ngFor="let contract of contractList; index as index">
                        <div class="-oneX-col-4">
                          <div class="photo-container">
                            <div class="photo-container-img">
                              <img
                                id="urp-photo-img-{{ index }}"
                                [src]="contract"
                                class="urp-photo-img"
                                alt="Contract part {{ index + 1 }} of {{ contractList.length }}"
                              />
                              <img
                                *ngIf="!isSubmitted"
                                src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjRweCIgaGVpZ2h0PSIyNHB4IiB2aWV3Qm94PSIwIDAgMjQgMjQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+cGFydHMvbm90aWZpY2F0aW9uL2ljb24vMjQvd2FybmluZyBjb3B5IDI8L3RpdGxlPgogICAgPGcgaWQ9Ik1vYmlsZS1UZXN0aW5nLTExLTE3LTIwIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBpZD0icGFydHMvbm90aWZpY2F0aW9uL2ljb24vMjQvd2FybmluZy1jb3B5LTIiIGZpbGwtcnVsZT0ibm9uemVybyI+CiAgICAgICAgICAgIDxjaXJjbGUgaWQ9IlNoYXBlIiBmaWxsPSIjNzY3Njc2IiBjeD0iMTIiIGN5PSIxMiIgcj0iMTIiPjwvY2lyY2xlPgogICAgICAgICAgICA8cG9seWdvbiBpZD0iUGF0aCIgZmlsbD0iI0ZGRkZGRiIgcG9pbnRzPSI3LjQ5MjExOTA5IDYgNiA3LjQ5MjExOTA5IDEwLjUwNzg4MDkgMTIgNiAxNi41MDc4ODA5IDcuNDgxNjExMjEgMTcuOTg5NDkyMSAxMiAxMy40ODE2MTEyIDE2LjUwNzg4MDkgMTggMTggMTYuNTA3ODgwOSAxMy40ODE2MTEyIDEyIDE3Ljk4OTQ5MjEgNy40ODE2MTEyMSAxNi41MDc4ODA5IDYgMTIgMTAuNTA3ODgwOSI+PC9wb2x5Z29uPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+"
                                tabindex="0"
                                alt=""
                                id="urp-photo-img-{{ index }}-delete"
                                class="delete-photo-icon"
                                (click)="deleteFile(index, $event)"
                                (keydown.enter)="deleteFile(index, $event)"
                              />
                            </div>
                          </div>
                        </div>
                      </ng-container>
                    </ng-template>
                  </div>
                  <div class="-oneX-row" style="justify-content: center; align-items: center">
                    <span
                      *ngIf="MAX_CONTRACT_PHOTOS - contractList.length === MAX_CONTRACT_PHOTOS && !isSubmitted"
                      id="addUpToNPhotosMessage"
                      data-testid="addUpToMessage"
                      class="-oneX-link--block upload-files-dropzone add-extra-photos-btn"
                      tabindex="0"
                      attr.aria-label="Add up to {{ MAX_CONTRACT_PHOTOS }} photos"
                      role="button"
                      >Add up to {{ MAX_CONTRACT_PHOTOS }} photos</span
                    >
                    <span
                      *ngIf="MAX_CONTRACT_PHOTOS - contractList.length !== 0 && contractList.length > 0 && !isSubmitted"
                      id="addUpToNPhotosMessage"
                      data-testid="addUpToMessage"
                      class="-oneX-link--block upload-files-dropzone add-extra-photos-btn"
                      tabindex="0"
                      attr.aria-label="Add up to {{ MAX_CONTRACT_PHOTOS - contractList.length }} photos"
                      role="button"
                      >Add up to {{ MAX_CONTRACT_PHOTOS - contractList.length }} more</span
                    >
                  </div>
                </div>
              </div>
              <div class="-oneX-body--tertiary input-error-text" *ngIf="hasFileSizeError">Max file size: 10mb</div>
              <div class="-oneX-body--tertiary input-error-text" *ngIf="hasFileTypeError">
                Accepted file extensions: .png, .jpeg, .jpg
              </div>
              <div class="-oneX-row -oneX-justify-content-center"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="-oneX-row -oneX-justify-content-center">
      <div
        class="-oneX-col-12 -oneX-offset-0 -oneX-col-sm-8 -oneX-offset-sm-0 -oneX-col-md-6 -oneX-offset-md-0 -oneX-col-lg-6 -oneX-offset-lg-0 -oneX-col-xl-6 -oneX-offset-xl-0"
      >
        <div
          id="contractorUploadSsnDisclaimer"
          data-testid="contractorUploadSsnDisclaimer"
          class="-oneX-body--tertiary disclaimer-text"
        >
          To protect sensitive information, do not include full SSN, TIN, SIN, DL#, financial account numbers,
          credit/debit card numbers, PHI, or any medical information.
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="!isSubmitted" class="-oneX-row -oneX-justify-content-center">
    <div
      class="-oneX-col-12 -oneX-offset-0 -oneX-col-sm-8 -oneX-offset-sm-0 -oneX-col-md-6 -oneX-offset-md-0 -oneX-col-lg-6 -oneX-offset-lg-0 -oneX-col-xl-6 -oneX-offset-xl-0 buttonContainer"
    >
      <div class="startButtonContainer">
        <button
          id="{{ isUpdated ? 'contractorSaveBtn' : 'contractorNextBtn' }}"
          data-testid="contractorNextBtn"
          type="submit"
          class="-oneX-btn-primary -oneX-btn-fit-content"
          (click)="onNextButtonClicked()"
          [disabled]="isNextDisabled()"
        >
          {{ isUpdated ? 'Save' : 'Next' }}
        </button>
      </div>
    </div>
  </div>
</div>
<app-doc-type-modal [id]="docTypesModalId"></app-doc-type-modal>
<app-long-contract-modal [id]="longContractModalId" (onHide)="openFilePicker()"></app-long-contract-modal>
<app-delete-contract-modal
  *ngIf="contractId"
  [id]="deleteContractModalId"
  [deleteContractId]="contractId!"
></app-delete-contract-modal>
